export default __webpack_public_path__ + "static/media/EVENT26Aside.42153d17.png";